import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query Case($id: ID!) {
  case(id: $id) {
    id
    name
    description
    insertedAt
    updatedAt
    comment
    activities {
      id
      duration
      insertedAt
      messagesCount
    }
  }
}`;

function getCaseById(id) {
  return apollo.client.query({
    variables: { id: parseInt(id, 10) },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.case).then((res) => {
    const result = { ...res };
    result.activities = result.activities.map((item) => ({ ...item, insertedAt: new Date(item.insertedAt) }));
    result.insertedAt = new Date(res.insertedAt);
    result.updatedAt = new Date(res.updatedAt);
    return result;
  });
}

export default getCaseById;
